import * as React from 'react';
import { useState, useEffect } from "react";

import {
    SearchInput
} from '@patternfly/react-core';

interface FilterProps {
    onSearch: CallableFunction,
    value: string | null,
    resultsCount: number | 0,
    placeholder: string,
}


const Filter: React.FunctionComponent<FilterProps> = ({ value, onSearch, resultsCount, placeholder }) => {

    const [search, setSearch] = useState<string>(value ? value : "");

    useEffect(() => {
        if (search != null) {
            setSearch(search)
        }
    }, [search])

    return (
        <>
            <SearchInput

                advancedSearchDelimiter=":"
                aria-label="name filter"
                placeholder={placeholder}
                value={search}
                onChange={(_event, _value) =>
                    setSearch(_value)
                }
                onClear={(_event) => {
                    setSearch("")
                    onSearch("")
                }}
                onSearch={(_event, _value) => {
                    setSearch(_value)
                    onSearch(_value)
                }
                }
                resultsCount={resultsCount}
            />
        </>
    )
}

export { Filter, FilterProps }